export default {
  BASE_URL: '/api',
  // BASE_URL: 'https://evaluation.test.pssads.com/api', // 开发
  // BASE_URL: 'https://evaluation.api.pssads.com/api', // 生产
  API_VERSION: 1.0,
  DEBUG: true
}

export const appNamespace = 'xsy'
